import { Injectable } from '@angular/core';
import { UserDto } from '@models/user-dto';
import { environment } from '@environments/environment';
import { JwtHelperService } from '@auth0/angular-jwt'; // add this manually
import { HttpClient } from '@angular/common/http'; // add manually
import { map } from 'rxjs/operators'; // add manually 
import { ReplaySubject, BehaviorSubject, Observable } from 'rxjs';
import { User } from '@models/user';
import { UserConfirmEmail } from '@models/user-confirm-email';
import { EmailDto } from '@models/email-dto';
import { CourseService } from './course.service';
// import { jwtDecode } from "jwt-decode";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private currentUserSource = new ReplaySubject<User>(1); //buffer to store 1 version of the current user
  currentUser$ = this.currentUserSource.asObservable(); //add dollar sign to end since it is an observable

  private adminStatusSubject = new BehaviorSubject<boolean>(false);
  adminStatus$ = this.adminStatusSubject.asObservable();
  
  baseUrl = environment.baseUrl + 'Auth/';
  jwtHelper = new JwtHelperService();
  decodedToken: any;
  currentUser: UserDto;
  roleAs: any;
  ccd: any;

 

  constructor(private http: HttpClient, public courseService: CourseService ) {
    this.decodedToken = this.decodeToken();
    // Initialize admin status on service creation
    this.updateAdminStatus();
   }


  login(model: any) {
    return this.http.post(this.baseUrl + 'login', model)
      .pipe(
        map((response: any) => {
          const user = response;
          if (user) {
            localStorage.setItem('token', user.token);
            localStorage.setItem('user', JSON.stringify(user.user));
            localStorage.setItem('ccd', JSON.parse(JSON.stringify(user.ccd)));
            localStorage.setItem('isCourseCompleted', "false");
            //   var now = new Date().getTime();
            //  localStorage.setItem('setupTime', now);


            this.decodedToken = this.jwtHelper.decodeToken(user.token);
            this.currentUser = <UserDto>user.user;

            // const isAdmin = this.decodedToken.role === 'Admin';
            //console.log(`IsAdmin: ${isAdmin}`);

            this.currentUser = <UserDto>user.user;

            /*if (isAdmin)
              {localStorage.setItem('ROLE', 'ROLE_ADMIN');}
              else
              {localStorage.setItem('ROLE', 'user');}*/
               
              //console.log(`IsAdmin1: ${isAdmin}`);
              //console.log(this.decodedToken);
              //console.log(JSON.stringify(user.user));

            // Update admin status based on token
            this.updateAdminStatus();
            this.currentUserSource.next(user);

          }
          else {
            // console.log(response);
          }
        })
      ); 
  }

  // getRole() {
  //   this.roleAs = localStorage.getItem('ROLE');
  //   return this.roleAs;
  // }

  /*getRole(): string {
    return localStorage.getItem('ROLE');
  }*/

  // Remove separate role storage - get role directly from token
  getRole(): string | null {
    const token = this.getValidToken();
    if (!token) return null;
    
    try {
      const decodedToken = this.jwtHelper.decodeToken(token);
      return decodedToken?.role || null;
    } catch (error) {
      console.error('Error decoding token for role:', error);
      return null;
    }
  }
  
  async getAdminStatus(): Promise<boolean> {
    try {
      const isAdmin = this.isAdmin; // Use the isAdmin getter
      this.adminStatusSubject.next(isAdmin);
      return isAdmin;
    } catch (error) {
      //console.log('Error determining admin status', error);
      this.adminStatusSubject.next(false);
      return false;
    }
  }

  /*get isAdmin(): boolean {
    const decodedToken = this.decodeToken();
    if (!decodedToken) {
      console.log('No valid token found');
      return false;
    }
    const result = decodedToken.role === 'Admin';
    //console.log(decodedToken.role);
    //console.log("isAdmin: " + result);
    return result;
  }*/

  /* Updated */
  get isAdmin(): boolean {
    const role = this.getRole();
    return role === 'Admin';
  }

  private updateAdminStatus(): void {
    const isAdmin = this.isAdmin;
    this.adminStatusSubject.next(isAdmin);
  }

  /* New */
  // Centralized token validation
  private getValidToken(): string | null {
    const token = localStorage.getItem('token');
    if (!token || this.jwtHelper.isTokenExpired(token)) {
      return null;
    }
    return token;
  }
  
  /*private decodeToken() {
    // Your logic to decode the token
    const token = localStorage.getItem('token');
    // Add your token decoding logic here
    return token ? JSON.parse(atob(token.split('.')[1])) : null;
  }*/

  /* Updated */
  // Improved token decoding with error handling
  private decodeToken(): any {
    const token = this.getValidToken();
    if (!token) return null;

    try {
      return this.jwtHelper.decodeToken(token);
    } catch (error) {
      console.error('Error decoding token:', error);
      return null;
    }
  }

  /*loggedIn() {
    const token = localStorage.getItem('token');
    return !this.jwtHelper.isTokenExpired(token);
  }*/

  /* Updated */
  loggedIn(): boolean {
    return !!this.getValidToken();
  }

  // Add logout method to clean up properly
  logout(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('ccd');
    localStorage.removeItem('isCourseCompleted');
    this.currentUserSource.next(null);
    this.adminStatusSubject.next(false);
  }




  getCD() {
    this.ccd = localStorage.getItem('ccd');
    return this.ccd;
  }

  changePassword(model: any) {
    return this.http.post(this.baseUrl + 'changepassword', model);
    /*
      .pipe(
        map((response: any) => {
          const user = response;
          if (user) {
            localStorage.setItem('token', user.token);
            localStorage.setItem('user', JSON.stringify(user.user));

            localStorage.setItem('isCourseCompleted', "false");
            
            //   var now = new Date().getTime();
            //  localStorage.setItem('setupTime', now);

            this.decodedToken = this.jwtHelper.decodeToken(user.token);
            this.currentUser = <UserDto>user.user;
            //console.log('cthis.currentUser: ' + this.currentUser);  // no return 
          }
        })
      );
      */
  }

  addToClass (model: any) {
    return this.http.post(this.baseUrl + 'addtoclass', model);
  }

  register(user: User) {
    return this.http.post(this.baseUrl + 'register', user);
  }

  confirmEmail(userConfirm: UserConfirmEmail) {

    return this.http.post(this.baseUrl + 'confirmation', userConfirm);
  }

  loginConfirmEmail(model: any) {
    return this.http.post(this.baseUrl + 'LoginConfirmEmail', model)
      .pipe(
        map((response: any) => {
          const user = response;
          if (user) {
            localStorage.setItem('token', user.token);
            localStorage.setItem('user', JSON.stringify(user.user));

            //   var now = new Date().getTime();
            //  localStorage.setItem('setupTime', now);

            this.decodedToken = this.jwtHelper.decodeToken(user.token);
            this.currentUser = <UserDto>user.user;
              }
        })
      );
  }

  returnCurrentUser() {
    this.currentUser = <UserDto>(JSON.parse(localStorage.getItem("user")));
    return JSON.parse(localStorage.getItem("user"));
  }

  returnCourseId() {
    return environment.courseId;
  }

  // returns string : "false":"true"
  getCourseCompleted() {
    return localStorage.getItem('isCourseCompleted');
  }

  setCourseCompleted() {
     localStorage.setItem('isCourseCompleted', "true");
  }

  sendEmailResetPassword(emailDto: EmailDto) {

    return this.http.post(this.baseUrl + 'loginHelp', emailDto);
  }

  // Debug method to test JWT token claims
  testTokenDebug(): Observable<any> {
    return this.http.get(environment.baseUrl + 'user/debug-token');
  }
 
 
}
